import React from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import ApplicationLayout from './layouts/ApplicationLayout/ApplicationLayout';
import AuthLayout from './layouts/AuthLayout/AuthLayout';
import CheckOrdersLayout from './layouts/CheckOrdersLayout/CheckOrdersLayout';
import CubageLayout from './layouts/CubageLayout/CubageLayout';
import FileUploadLayout from './layouts/FileUploadLayout/FileUploadLayout';
import ListNotfisLayout from './layouts/ListNotfisLayout/ListNotfisLayout';
import LoginLayout from './layouts/LoginLayout/LoginLayout';
import ParceirosLayout from './layouts/ParceirosLayout/ParceirosLayout';
import CheckOrders from './pages/CheckOrders/CheckOrders';
import Help from './pages/CheckOrders/Help/Help';
import Cubage from './pages/Cubage/Cubage';
import ListNotfis from './pages/ListNotfis/ListNotfis';
import Parceiros from './pages/Parceiros/Parceiros';
import UploadFast from './pages/UploadFast/UploadFast';
import { selectAuthAttributs } from './redux/features/generalData/generalDataSelectors';

const App: React.FunctionComponent = (): JSX.Element => {
  const auth = useSelector(selectAuthAttributs);
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AuthLayout />}>
          {auth === 'LoggedOut' && (
            <Route path="/" element={<LoginLayout />}>
              <Route path="*" element={<Navigate to="/" />} />
            </Route>
          )}
          {auth === 'LoggedIn' && (
            <Route path="/" element={<ApplicationLayout />}>
              <Route index element={<Navigate to="Etiquetar" />} />

              {/* Etiquetar */}
              <Route path="Etiquetar" element={<CheckOrdersLayout />}>
                <Route index element={<CheckOrders />} />
              </Route>

              {/* Etiquetar */}
              <Route path="consultar-notfis" element={<ListNotfisLayout />}>
                <Route index element={<ListNotfis />} />
              </Route>

              {/* CUBAGEM */}
              <Route path="cubagem" element={<CubageLayout />}>
                <Route index element={<Cubage />} />
              </Route>

              {/* NOTFIS FAST-SHOP */}
              <Route path="notfis-fast" element={<FileUploadLayout />}>
                <Route index element={<UploadFast />} />
              </Route>

              {/* NOTFIS FAST-SHOP */}
              <Route path="parceiros" element={<ParceirosLayout />}>
                <Route index element={<Parceiros />} />
              </Route>

              {/* AJUDA */}
              <Route path="ajuda/navegador">
                <Route index element={<Help />} />
              </Route>

              <Route path="*" element={<Navigate to="/" />} />
            </Route>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
